module.exports = __webpack_public_path__ + "img/Plus.49ae65ef.svg";